// extracted by mini-css-extract-plugin
export default {"appbar":"AppBar_appbar__cxg4F","backBtn":"AppBar_backBtn__lf3vp","backBtnImage":"AppBar_backBtnImage__+PV55","title":"AppBar_title__EaBrz"};